<template>
	<article class="factor-page">
		<managing-section :column-count="2">
			<managing-box title="제품검색">
				<input
					ref="wordInput"
					v-model="word"
					type="text"
					@keyup.enter="enterSearchProduct"
					placeholder="검색어 + Enter"
				/>
			</managing-box>
			<managing-box title="제품선택">
				<select
					class="select"
					v-model="selectedProductId"
					@change="changeProductId"
				>
					<option
						v-for="item in productList"
						:key="item.id"
						:value="item.id"
					>
						{{ item.title }}
					</option>
				</select>
			</managing-box>
			<managing-box title="항번검색" :is-block-box="true">
				<input-text
					ref="idInput"
					@input="inputId"
					mode="number"
					:input-width="120"
					placeholder="제품항번"
				/>
				<button
					class="btn factor__id-search-btn"
					type="button"
					@click="searchById"
				>
					검색
				</button>
			</managing-box>
		</managing-section>
		<managing-section :is-table="true">
			<template v-if="productTitle" slot="infoSection">
				<p class="section__info__left">{{ productTitle }}</p>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th v-for="th in thList" :key="th">{{ th }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in factorList" :key="idx">
						<td>{{ idx + 1 }}</td>
						<td class="text-left">{{ item.name }}</td>
						<td class="text-left">{{ item.purpose }}</td>
						<td>{{ item.min }}</td>
						<td>{{ item.max }}</td>
						<td>{{ item.count | currency }}</td>
					</tr>
				</tbody>
			</table>
		</managing-section>
	</article>
</template>

<script>
	import _ from 'lodash';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import InputText from '@/components/InputText.vue';

	export default {
		name: 'Factor',
		components: { ManagingSection, ManagingBox, InputText },
		data() {
			return {
				word: '',
				thList: [
					'NO',
					'성분',
					'사용목적',
					'MIN',
					'MAX',
					'해당성분 사용 제품 수',
				],
				selectedProductId: null,
				idProduct: '',
				productList: [{ title: '검색하세요', id: null }],
				factorList: [],
				productTitle: '',
			};
		},
		mounted() {
			this.setFilter();
		},
		methods: {
			async setFilter() {
				const query = this.$route.query;
				const productTitle = query.productTitle;
				const idProduct = query.idProduct;
				const word = query.word;
				const selectedProductId = query.selectedProductId;
				if (productTitle && (idProduct === 0 || idProduct)) {
					this.$refs.idInput.value = idProduct.toString();
					this.productList = [
						{ title: productTitle, id: Number(idProduct) },
					];
					this.selectedProductId = Number(idProduct);
					await this.getFactorList(Number(idProduct));
				} else if (
					word &&
					(selectedProductId === 0 || selectedProductId)
				) {
					this.word = word;
					await this.getProductList();
					this.selectedProductId = Number(selectedProductId);
					await this.getFactorList(Number(selectedProductId));
				}
			},
			pushQuery(type) {
				const query = {};
				if (type === 'id') {
					query.productTitle = this.productList[0].title;
					query.idProduct = this.productList[0].id;
				} else if (type === 'select') {
					query.word = this.word;
					query.selectedProductId = this.selectedProductId;
				}
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			async getProductList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/products`,
						{ params: { word: this.word } }
					);
					if (!data.products.length) return;
					this.productList = data.products.reduce(
						(acc, curr) => {
							acc.push({
								title: `${curr.isDiscontinue ? '[단종]' : ''}[${curr.brandTitle}] ${curr.productTitle}`,
								id: curr.idProduct,
							});
							return acc;
						},
						[{ title: '제품을 선택하세요', id: null }]
					);
				} catch (err) {
					console.error(err);
					alert('상품목록을 불러오는데 실패했습니다.');
				}
			},
			enterSearchProduct: _.debounce(async function () {
				await this.getProductList();
				this.selectedProductId = null;
				this.idProduct = '';
				this.$refs.idInput.init();
			}, 500),
			inputId(idProduct) {
				this.idProduct = idProduct;
			},
			async getFactorList(productId) {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/analysis/factor/product/${productId}`
					);
					this.productTitle = '';
					if (!data.productTitle) return false;
					this.productTitle = `${data.productTitle} (${data.factors.length})`;
					this.factorList = data.factors;
					return true;
				} catch (err) {
					console.error(err);
					alert('성분목록을 불러오는데 실패했습니다.');
					return false;
				}
			},
			async searchById() {
				try {
					const hasFactorList = await this.getFactorList(
						this.idProduct
					);
					if (!hasFactorList) return;
					this.word = '';
					this.$refs.wordInput.value = '';
					this.selectedProductId = this.idProduct;
					this.productList = [
						{ title: this.productTitle, id: this.idProduct },
					];
					this.pushQuery('id');
				} catch (err) {
					console.error(err);
					alert('성분목록을 불러오는데 실패했습니다.');
				}
			},
			async changeProductId() {
				await this.getFactorList(this.selectedProductId);
				this.pushQuery('select');
			},
		},
	};
</script>

<style lang="scss">
	.factor-page .factor__id-search-btn {
		display: inline-block;
		margin-top: 3px;
		margin-left: 3px;
	}
</style>
